module.exports = __webpack_public_path__ + "img/skridsko_trad.0affff2f.jpg";